import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7h6c0 2.5 -1.593 8.474 -6 10","key":"svg-0"}],["path",{"d":"M16 5v14z","key":"svg-1"}],["path",{"d":"M16 12h2","key":"svg-2"}]]

const IconAlphabetKorean = createReactComponent('outline', 'alphabet-korean', 'AlphabetKorean', __iconNode);

export default IconAlphabetKorean;